export default {
  buildCreate(providerIdentifier, customerId, templateId) {
    return {
      'data': {
        'attributes': {
          'provider-identifier': providerIdentifier,
          'customer-id': customerId,
          'template-id': templateId,
        },
        'type': 'conversations',
      },
    };
  },
  buildUpdate(id, assignedAgentId, status, group) {
    return {
      'data': {
        'attributes': {
          'assigned-agent-id': assignedAgentId,
          'assigned-group-id': group,
          'status': status,
        },
        'type': 'conversations',
        'id': id,
      },
    };
  },
  async createConversation(data, axios, token) {
    return await axios.post('/api/message/conversations/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async updateConversation(conversationId, data, axios, token) {
    return await axios.patch(`/api/message/conversations/${conversationId}/`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
};
